var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.778 1.132a8.44 8.44 0 0 1 8.444 0L56.59 12.911a8.43 8.43 0 0 1 4.212 7.3V43.79a8.43 8.43 0 0 1-4.212 7.3L36.222 62.868a8.44 8.44 0 0 1-8.444 0L7.41 51.09a8.43 8.43 0 0 1-4.212-7.3V20.21a8.43 8.43 0 0 1 4.212-7.3zM32 10.406c-11.872 0-21.495 9.668-21.496 21.594S20.128 53.594 32 53.594 53.496 43.926 53.496 32 43.87 10.406 32 10.406"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.612 20.498c-.373-1.086-.971-1.086-1.345 0l-2.069 6.12c-.362 1.086-1.558 2.274-2.628 2.649l-6.067 2.073c-1.084.375-1.084.973 0 1.348l6.028 2.098c1.084.375 2.267 1.574 2.643 2.649l2.104 6.133c.374 1.087.972 1.087 1.345 0l2.055-6.094c.363-1.087 1.545-2.275 2.63-2.65l6.154-2.111c1.084-.375 1.084-.973 0-1.337l-6.056-2.048c-1.084-.361-2.267-1.55-2.643-2.636-.035-.01-2.151-6.194-2.151-6.194"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })))));
};
export default SvgLogo;